import React, { useEffect, useState } from 'react'
import { firebaseSetListener } from '../../../refactory/services/firebase/firebase'
import { addJobs, selectJob, updateJobStatistics } from '@actions/jobList'
import Flag from './flag.component'
import { Can } from '../../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { SubModulePerms } from '../../../refactory/modules/access-control/domain/module'
import { useParams } from 'react-router-dom'
const CLIENTS = 'clients'
const AGENTS = 'agents'
const JOB_CARDS = 'jobCards'

let unsubscribe = null
let timer = {
  active: false,
  id: null
}
let currentJob = null

const FlagList = (props) => {
  const { jobId } = useParams()
  const [selectedJobAlert, setSelectedJobAlert] = useState()
  const { dispatch, state, currentUser } = props
  const { selectedJob } = state
  currentJob = selectedJob

  const sort = (arrayObjects) => {
    return arrayObjects.sort((a, b) => {
      return b.priority - a.priority
    })
  }

  const getJobSelected = (jobs, jobId) => {
    return jobs.find((job) => job.id === jobId)
  }

  useEffect(() => {
    if (jobId && state.jobs.length) {
      const jobFound = state.jobs.find((job, index) => {
        if (job.key === jobId) {
          job.index = index
          return job
        }
        return false
      })

      setSelectedJobAlert(jobFound)
    }
  }, [state.jobs])

  useEffect(() => {
    const setJobs = (snapshot) => {
      const {
        user: { id: userId, stores }
      } = currentUser
      if (snapshot) {
        let cards = []
        if (stores && stores.length > 0) {
          snapshot.forEach((doc) => {
            let jobCard = doc.data()
            jobCard.key = doc.id
            if (stores.includes(jobCard.storeId)) {
              cards.push(jobCard)
            }
          })
        } else {
          snapshot.forEach((doc) => {
            let jobCard = doc.data()
            jobCard.key = doc.id
            cards.push(jobCard)
          })
        }
        updateJobStatistics(userId, cards, dispatch)
        const sortedJobs = sort(cards)
        addJobs(sortedJobs, dispatch)

        const currentJobSelected = getJobSelected(sortedJobs, currentJob ? currentJob.id : 0)
        if (currentJobSelected) {
          selectJob(currentJobSelected, 0, dispatch)
        }
      }
    }

    const startListenJobCards = (clientId, agentId) => {
      if (unsubscribe) unsubscribe()
      const path = `${CLIENTS}/${String(clientId)}/${AGENTS}/${String(agentId)}/${JOB_CARDS}`
      unsubscribe = firebaseSetListener(path, null, setJobs)
    }

    const startToListenAllJobCards = (clientId) => {
      if (unsubscribe) unsubscribe()
      const path = `${CLIENTS}/${String(clientId)}/${JOB_CARDS}`
      unsubscribe = firebaseSetListener(path, null, setJobs)
    }
    const getJobList = () => {
      if (currentUser && currentUser.user.id !== '') {
        const {
          user: { id, clientId }
        } = currentUser
        if (Can([SubModulePerms.FLA_GENERAL_ALL_SEE])) {
          startToListenAllJobCards(clientId)
        } else {
          startListenJobCards(clientId, id)
        }
      }
    }
    if (!unsubscribe) {
      getJobList()
    }

    return () => {
      clearInterval(timer.id)
      timer = {
        active: false,
        id: null
      }
      if (unsubscribe) {
        unsubscribe()
        unsubscribe = null
      }
    }
  }, [currentUser, dispatch, props.currentUser])

  return <Flag {...props} selectedJobAlert={selectedJobAlert} />
}

export default FlagList
